/* eslint-disable no-undef */
var onboardingToken = process.env.ONBOARDING_TOKEN;
var minTokenLength = 30;
var isToken = typeof onboardingToken === 'string' && onboardingToken.length > minTokenLength;

if (isToken) {
  var script = document.createElement('script');

  script.onload = function () {
    Experrto.identify(onboardingToken);
    console.log('Onboarding is enabled');
  };

  script.src = 'https://cdn.experrto.io/client/experrto.js';
  document.head.appendChild(script);
} else {
  console.log('Onboarding is disabled');
}